import React from 'react';
import Header from './Header';
import Foot from './Foot';
import FeedbackChatbot from './FeedbackChatbot'; // nouveau composant à créer

const MainLayout = ({ children, toggleTheme, isDarkMode }) => {
  return (
    <div className={isDarkMode ? 'dark-mode' : 'light-mode'}>
      <Header toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
      <div className="feature-area pt-80 pb-50">
        {children}
      </div>
      <Foot />
      <FeedbackChatbot /> {/* Ajout ici */}
    </div>
  );
};

export default MainLayout;
